// Get Discord UID from multiple sources (prioritized)
export const getDiscordUID = () => {
  // Try localStorage first (cross-domain friendly)
  let uid = localStorage.getItem('discord_uid');
  if (uid) return uid;
  
  // Fallback to existing cookies
  uid = getCookie('discord_id') || getCookie('discordUID');
  if (uid) {
    // Store in localStorage for future cross-domain use
    localStorage.setItem('discord_uid', uid);
    return uid;
  }
  
  // Check URL params (for cross-domain linking)
  const urlParams = new URLSearchParams(window.location.search);
  uid = urlParams.get('discord_uid');
  if (uid) {
    // Store locally and clean URL
    localStorage.setItem('discord_uid', uid);
    window.history.replaceState({}, '', window.location.pathname);
    return uid;
  }
  
  return null;
};

// Helper function to get cookies
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Create cross-domain links
export const createCrossDomainLink = (targetUrl) => {
  const discordUid = getDiscordUID();
  if (!discordUid) return targetUrl;
  
  const url = new URL(targetUrl);
  url.searchParams.set('discord_uid', discordUid);
  return url.toString();
};

// Clear stored UID (for logout)
export const clearDiscordUID = () => {
  console.log('=== clearDiscordUID DEBUG ===');
  console.log('Before clear - localStorage discord_uid:', localStorage.getItem('discord_uid'));
  localStorage.removeItem('discord_uid');
  console.log('After clear - localStorage discord_uid:', localStorage.getItem('discord_uid'));
};

// Test function to check what Discord data is available
export const debugDiscordAuth = () => {
  console.log('=== MAIN APP DISCORD DEBUG ===');
  console.log('localStorage discord_uid:', localStorage.getItem('discord_uid'));
  console.log('Cookie discord_id:', getCookie('discord_id'));
  console.log('Cookie discordUID:', getCookie('discordUID'));
  console.log('Full cookies:', document.cookie);
  
  const uid = getDiscordUID();
  console.log('Final detected UID:', uid);
  
  if (uid) {
    console.log('WUMZ Game Link:', createCrossDomainLink('http://localhost:3000'));
  } else {
    console.log('No UID detected - cannot create cross-domain link');
  }
  
  return uid;
};